export function RuntimeBanner() {
  return null;
}